import React from "react";

export default function Error404() {
  return (
    <div className="App pb-5">
      <div className="alert alert-danger" role="alert">
        404 Page Not Found
      </div>
    </div>
  );
}
